// import { apiEleg } from '../../config/api'
import {
  CallApiSinToken,
  CallCurrency,
  getElegibilidad,
  getDraftForms,
  getLocation,
  postElegibilidad,
} from '../../config/apiSinToken'

/**
 * AUTHOR: wraudales@ngshn.com 30/6/2022
 *  Este service es para traer la info de prelegibilidad de acuerdo al Id del Proyecto
 */
export const getPrelegibilityInfo = (params) => {
  return CallApiSinToken.getPrelegibilidad(
    `api/v1/ProjectsForms/project-forms-find/${params}`,
  )
}
/**
 * AUTHOR: gdegrandez@ngshn.com 7/7/2022
 *  Este service es para traer la info de prelegibilidad de acuerdo al ID del usuario
 */
// export const getMipymeByUser = (params) => {
//   console.log('paramrtro', params)
//   const data = CallApiSinToken.getMYPYMESById(
//     `api/v1/MiPymes/preElegibleStateByUser/${params}`,
//   )
//   console.log('la data del get', data)
//   return data
// }

export const getMipymeByUser = async (params) => {
  const data = await getElegibilidad(
    `api/v1/MiPymes/preElegibleStateByUser/${params}`,
  )
  return data
}
/**
 * Author: wraudales@ngshn.com
 * Este enpoint trae los proyectos de la mipyme con estado elegible
 * 10-7-2022
 */
export const getProjectByMiPYME = async (params) => {
  const data = await getElegibilidad(
    `api/v1/Projects/preElegibleByMiPyme/${params}`,
  )
  return data
}
/**
 * Author: wraudales@ngshn.com
 * Este enpoint trae la información de los proyectos que tiene dicha mipyme
 * 10-7-2022
 */
export const getProjectForm = async (params) => {
  const data = await getElegibilidad(
    `api/v1/ProjectsForms/project-forms-find/${params}`,
  )
  return data
}

export const getCurrencyByCountry = async (params) => {
  const data = await getElegibilidad(
    `api/v1/Currencies/currenciesByCountry/${params}`,
  )

  return data
}
/**
 * Author: wraudales@ngshn.com
 * Este enpoint trae los borradores para enlistar en la pantalla consulta formulario
 * 19-7-2022
 */
export const getDraftFormsByUser = async (params) => {
  const data = await getDraftForms(`api/v1/Forms/getForms/${params}/${true}`)
  return data
}

/**
 * Author: wraudales@ngshn.com
 * Este enpoint trae los formularios enviados del mipymes
 * 19-7-2022
 */
export const getSentFormsByUser = async (params) => {
  const data = await getDraftForms(`api/v1/Forms/getForms/${params}/${false}`)
  return data
}
/**
 * Author: wraudales@ngshn.com
 * Este enpoint traer el formulario de elegibilidad por Id De Formulario
 * 19-7-2022
 */
export const getFormByIdForm = async (params) => {
  const data = await getDraftForms(
    `api/v1/ElegibilityAnswers/FindEligibilityForm/${params}`,
  )
  return data
}

export const getIfisByCountry = async (params) => {
  const data = await getElegibilidad(`api/v1/IFIS/IFIsListByCountry/${params}`)
  return data
}

export const getCurrency = (data) => {
  return CallCurrency(
    // `api/public-reference-data-management-x/v1.0/global-standard-specification/currency-exchange/retrieve/`,
    data,
  )
}

export const getLocationsByForm = async (params) => {
  const data = await getLocation(
    `api/v1/ProjectDevelopmentLocation/getLocationsByForm/${params}`,
  )
  return data
}

// Funcion para obtener tabla 6 Seccion 3 (pérdida de activos debido al cambio climatico)
export const getAssetsByForm = async (params) => {
  const data = await getElegibilidad(
    `api/v1/AssetsLossClimate/getAssetsByForm/${params}`,
  )
  return data
}

// Funcion para obtener tabla 3Seccion 3 (producción y número de hectáreas expuestas a los efectos del cambio y a la variabilidad climática)
export const getProductionAndLossByForm = async (params) => {
  const data = await getElegibilidad(
    `api/v1/ProductionAndLossesByClimate/getProductionAndLossByForm/${params}`,
  )
  return data
}

// Funcion para los sectores
export const getSectorList = async () => {
  const data = await getElegibilidad(`api/v1/Sectors/sectorList`)
  return data
}

// Funcion para obtener tabla 9.1 Seccion 3
export const getActivitiesByForm = async (params) => {
  const data = await getElegibilidad(
    `api/v1/ProductiveActivitiesPlanning/getActivitiesByForm/${params}`,
  )
  return data
}

// Funcion para ingresar los registros default
export const insertDefaultValues = async (params) => {
  const data = await getElegibilidad(
    `api/v1/ElegibilityAnswers/insertDefaultValues/${params}`,
  )
  return data
}

// Funcion para la tabla 3.9.3
export const getBarriersByForm = async (params) => {
  const data = await getElegibilidad(
    `api/v1/MarketAccessBarriers/getBarriersByForm/${params}`,
  )
  return data
}

// Funcion para la tabla 3.9.6
export const getEnergyUsedProductionByForm = async (params) => {
  const data = await getElegibilidad(
    `api/v1/EnergyUsedProduction/getEnergyUsedProductionByForm/${params}`,
  )
  return data
}

// Funcion para la tabla 3.9.6
export const getManagementSoilsPracticesByForm = async (params) => {
  const data = await getElegibilidad(
    `api/v1/ManagementSoilsPractices/getManagementSoilsPracticesByForm/${params}`,
  )
  return data
}

// Funcion para la tabla 4.1 Seccion 4
export const getGenderActivitiesByForm = async (params) => {
  const data = await getElegibilidad(
    `api/v1/GenderActivities/ListByForm/${params}`,
  )
  return data
}

// Funcion para la tabla 5.2 Seccion 5
export const getAdaptationMeasuresByForm = async (params) => {
  const data = await getElegibilidad(
    `api/v1/AdaptationMeasures/getAdaptationMeasuresByForm/${params}`,
  )
  return data
}

// Funcion para la tabla 3.9.7 Seccion 3
export const getIrrigationSystemsByForm = async (params) => {
  const data = await getElegibilidad(
    `api/v1/IrrigationSystems/ListByForm/${params}`,
  )
  return data
}

// Funcion para la tabla 3.9.5 Seccion 3
export const getServicesAccess = async (params) => {
  const data = await getElegibilidad(
    `api/v1/ServicesAccess/GetByForm/${params}`,
  )
  return data
}

// Funcion para el modal 3.9.7 (select fuente de agua)
export const getWaterSources = async () => {
  const data = await getElegibilidad(`api/v1/WaterSources/getWaterSources`)
  return data
}

// Funcion para el modal 3.9.7 (select metodo de riego)
export const getIrrigationTechniques = async () => {
  const data = await getElegibilidad(
    `api/v1/IrrigationTechniques/getIrrigationTechniques`,
  )
  return data
}

// Funcion para la tabla 3.9.8
export const getUsedFertilizersByForm = async (params) => {
  const data = await getElegibilidad(
    `api/v1/UsedFertilizers/getUsedFertilizersByForm/${params}`,
  )
  return data
}

// Funcion para el modal 3.9.8(Tipos de fertilizantes)
export const getFertilizersTypes = async () => {
  const data = await getElegibilidad(
    `api/v1/FertilizersTypes/getFertilizersTypes`,
  )
  return data
}

// Funcion para la tabla 5.3 dataGanttDev seccion 5
export const getImplementationScheduleByForm = async (params) => {
  const data = await getElegibilidad(
    `api/v1/ImplementationSchedule/getImplementationScheduleByForm/${params}`,
  )
  return data
}
// Seccion 6
export const getManagementPlanMitigations = async (params) => {
  const data = await getElegibilidad(
    `api/v1/ManagementPlanMitigations/ListByFormAndImpact/${params}`,
  )
  return data
}

// Funcion para la tabla 5.4 (presupuesto) seccion 5
export const getMasterSubprojectBudget = async (params) => {
  const data = await getElegibilidad(
    `api/v1/SubprojectBudget/getMasterSubprojectBudget/${params}`,
  )
  return data
}

// Funcion para la tabla 5.4.1 (presupuesto) seccion 5
export const getMasterDetailSubProyect = async ({
  IdElegibilityAnswer,
  IdCategory,
}) => {
  const data = await getElegibilidad(
    `api/v1/SubprojectBudget/getMasterDetailSubProyect/${IdElegibilityAnswer}/${IdCategory}`,
  )
  return data
}

// TODO: Corrregir
// funcion para el modal 5.4 de la tabla 5.4 (obtener las categorias de presupuesto)
export const getCategoriaPresupuesto = async () => {
  const data = await getElegibilidad(
    `api/v1/DataFields/listCategoriasPresupuesto`,
  )
  return data
}
// Seccion 6
export const getMitigationMeasures = async (params) => {
  const data = await getElegibilidad(
    `api/v1/MitigationMeasures/ListByEnvironmentalImpact/${params}`,
  )
  return data
}

export const validateSubmitForm = async (params) => {
  const data = await postElegibilidad(
    `api/v1/Forms/ValidateSubmitForm/${params.idForm}/${params.userIDB2C}`,
    {},
  )
  return data
}

export const getManagementPlanList = async (params) => {
  const data = await getElegibilidad(
    `api/v1/EnvironmentalManagementPlan/ListByElegibilityAnswer/${params}`,
  )
  return data
}

// funcion para  Dashboard, validacion usuario
export const validatePreElegibilityFormByUser = async (params) => {
  const data = await getElegibilidad(
    `api/v1/Users/validatePreElegibilityFormByUser/${params}`,
  )
  return data
}

/**
 * Author: wraudales@ngshn.com
 * Fecha: 19-9-2022
 * Description: Funcion para traer el resumen de pre elegibilidad
 */
export const getPrelegibilitySummary = async (params) => {
  const data = await getElegibilidad(
    `api/v1/FormPreElegibility/getFormSummaryById/${params}`,
  )
  return data
}
/**
 * Author: wraudales@ngshn.com
 * Fecha: 19-9-2022
 * Description: Funcion para traer el formulario completo de Elegibilidad
 */
export const getElegibilityForm = async (params) => {
  const data = await getElegibilidad(
    `api/v1/Forms/geElegibilityFullForm/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 04-11-2022
 * Description: Funcion para traer las preguntas de un especifico workshop
 */
export const getQuestionWorkshop = async (params) => {
  const data = await getElegibilidad(
    `api/v1/Workshop/Test/get-idTest/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 09-11-2022
 * Description: Funcion para obtener la mipymes con workshop de un usuario
 */
export const getMipymesWorkshop = async (params) => {
  const data = await getElegibilidad(
    `api/v1/Users/MiPymeUserB2C/WorkShop/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 09-11-2022
 * Description: Funcion para verificar que el workshop le pertenezca a esa mipyme
 */
export const verifyMipymeAndWorkshop = async ({ IdMiPyme, CodWorkshop }) => {
  const data = await getElegibilidad(
    `api/v1/Workshop/MiPyme-Workshop/${IdMiPyme}/${CodWorkshop}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 09-11-2022
 * Description: Funcion para verificar  los intentos en el workshop
 */
export const verifyWorkshopAttempts = async (params) => {
  const data = await getElegibilidad(`api/v1/Workshop/Workshop-Test/${params}`)
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 29-11-2022
 * Description: funcion para verificar si la ifi tiene plan de accion
 */
export const getIfiActionPlan = async (params) => {
  const data = await getElegibilidad(`api/v1/IFIS/GetIFIActionPlan/${params}`)
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 29-11-2022
 * Description: funcion para verificar si la ifi tiene plan de accion
 */
export const getReportActionPlan = async (params) => {
  const data = await getElegibilidad(
    `api/v1/Report/Report/Action-Plan/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 12-12-2022
 * Description: funcion para obtener el reporte de la seccion1 Elegibilidad
 */
export const getReportSeccion1 = async (params) => {
  const data = await getElegibilidad(
    `api/v1/Report/Report/Elegibilidad-Seccion1/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 12-12-2022
 * Description: funcion para obtener el reporte de la seccion2 Elegibilidad
 */
export const getReportSeccion2 = async (params) => {
  const data = await getElegibilidad(
    `api/v1/Report/Report/Elegibilidad-Seccion2/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 07-02-2023
 * Description: funcion para obtener el reporte sin plan de accion
 */
export const getReportWithoutPlan = async (params) => {
  const data = await getElegibilidad(
    `api/v1/Report/Report/Elegibilidad-without-plan/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 07-02-2023
 * Description: funcion para obtener el reporte con plan de accion
 */
export const getReportWithPlan = async (params) => {
  const data = await getElegibilidad(
    `api/v1/Report/Report/Elegibilidad-with-plan/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Fecha: 17-08-2023
 * Description: status mipymes
 */
export const getStatusMipyme = async (params) => {
  const data = await getElegibilidad(`api/v1/MiPymes/MiPymes/Status/${params}`)
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Funcion para obtener la validacion de las actividades
 * Fecha: 28-08-2023
 */
export const getValidationImplementationActivityElegibility = async (
  id,
  StartExecutionPeriod,
  EndExecutionPeriod,
) => {
  const data = await getElegibilidad(
    `api/v1/ElegibilityAnswers/ImplementationSchedule/Validation/${id}?StartExecutionPeriod=${StartExecutionPeriod}&EndExecutionPeriod=${EndExecutionPeriod}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Obtiene la informacion de las hectareas del proyecto
 * Fecha: 30-08-2023
 */
export const getPreElegibilityAnswerByProject = async (params) => {
  const data = await getElegibilidad(
    `api/v1/FormPreElegibility/getPreElegibilityAnswerByProject/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Obtiene el area de la tabla 3.3
 * Fecha: 28-09-2023
 */
export const getAreaProductionAndLoss = async (params) => {
  const data = await getElegibilidad(
    `api/v1/ProductionAndLossesByClimate/category/product/${params}`,
  )
  return data
}

/**
 * Author: gdegrandez@ngshn.com
 * Descripcion: Obtiene Si lleno el plan de accion
 * Fecha: 21-02-2024
 */
export const getManagementPlanMitigationsIsTherePlanMitigations = async (
  params,
) => {
  const data = await getElegibilidad(
    `api/v1/ManagementPlanMitigations/IsTherePlanMitigations/${params}`,
  )
  return data
}
